import {useMutation, useQueryClient} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type SetLinkedAccountsVisibilityResponse = {
  success: boolean;
  data?: {profile_visibility?: {linked_accounts?: boolean}};
};

// POST learning/update_user_settings/ -- owner-only toggle for the Linked
// Accounts (Lichess/Chess.com) card's visibility to non-owner viewers.
// Persists to CCUserSettings.profile_visibility.linked_accounts (see chess
// repo's player_profile/services/overview.py PROFILE_VISIBILITY_DEFAULTS /
// _field_visible -- defaults hidden until the owner opts in here). Same
// generic settings endpoint the Settings screen's `location` toggle already
// uses, just invoked from the profile page's kebab menu instead.
// Invalidates the owner's profile queries on success so the kebab menu and
// Linked Accounts card reflect the new state without a manual refetch.
export const useSetLinkedAccountsVisibilityApi = (
  username?: string | null,
) => {
  const qc = useQueryClient();
  return useMutation(
    async (visible: boolean): Promise<SetLinkedAccountsVisibilityResponse> =>
      (
        await ChessRestClient.post('learning/update_user_settings/', {
          profile_visibility: {linked_accounts: visible},
        })
      ).data,
    {
      onSuccess: () => {
        if (username) {
          qc.invalidateQueries(['playerProfile', username]);
        }
        qc.invalidateQueries(['playerProfile', 'me']);
      },
    },
  );
};

export default useSetLinkedAccountsVisibilityApi;
